import { EventName } from '@lit/react';
import { PdsPagination as PdsPaginationElement } from '@principal/design-system';
import * as React from 'react';
import { PdsPaginationProps } from '../../built-component-props';
import { createPdsReactComponent } from '../../create-pds-react-component';

export const PdsPagination = createPdsReactComponent<PdsPaginationProps>()({
  tagName: 'pds-pagination',
  elementClass: PdsPaginationElement,
  react: React,
  events: {
    onHandleClick: 'pds-pagination-click' as EventName<CustomEvent>,
  },
});
